module.exports = __webpack_public_path__ + "static/media/ibanfirst-logo.12aa3ced.svg";